import React from 'react'
import PropTypes from 'prop-types'

import { useGetQuery } from '../../lib/api/get'
import { useCreateCall } from '../../lib/api/create'
import { useUpdateCall } from '../../lib/api/update'
import { useDeleteCall } from '../../lib/api/delete'

import '../../assets/css/switch.css'

export const ProjectPages = ({ closePages, pagesContent, isLocalEnvironment, authDetails }) => {
  const [errorsAdd, setErrorsAdd] = React.useState({})
  const [errors, setErrors] = React.useState({})
  const [addPage, setAddPage] = React.useState(null)
  const [editPage, setEditPage] = React.useState(false)
  const [editPageData, setEditPageData] = React.useState(false)
  const [deleteData, setDeleteData] = React.useState(null)
  const [deleteConfirm, setDeleteConfirm] = React.useState(false)

  const createCallMutation = useCreateCall()
  const updateCallMutation = useUpdateCall()
  const deleteCallMutation = useDeleteCall()
  const getProjectDetails = useGetQuery({
    apiURL: isLocalEnvironment + '/getData',
    apiEndpoint: 'websitePages',
    params: `&websiteProjectId=${pagesContent.websiteProjectId}&isDependency=true`,
    isDynamic: true,
  })

  const createPage = async (e) => {
    e.preventDefault()
    if (e.target.websitePageName.value === '' || e.target.websitePageName.value === null) {
      setErrorsAdd({ ...errorsAdd, websitePageName: { message: 'Page name is required!' } })
      return
    }
    if (
      errorsAdd.websitePageName &&
      (e.target.websitePageName.value !== '' || e.target.websitePageName.value !== null)
    ) {
      delete errorsAdd['websitePageName']
      setErrorsAdd(errorsAdd)
    }
    if (e.target.websitePageTitle.value === '' || e.target.websitePageTitle.value === null) {
      setErrorsAdd({ ...errorsAdd, websitePageTitle: { message: 'Page title is required!' } })
      return
    }
    if (
      errorsAdd.websitePageTitle &&
      (e.target.websitePageTitle.value !== '' || e.target.websitePageTitle.value !== null)
    ) {
      delete errorsAdd['websitePageTitle']
      setErrors(errorsAdd)
    }
    const data = {
      websiteProjectId: pagesContent.websiteProjectId,
      websitePageName: e.target.websitePageName.value,
      websitePageTitle: e.target.websitePageTitle.value,
    }
    await createCallMutation
      .mutateAsync({
        url: isLocalEnvironment + '/addData',
        apiEndpoint: 'websitePages',
        data: data,
        messageTitle: 'Websites',
        message: 'New page added!',
        isDynamic: true,
        params: '&pageName=websitePages',
      })
      .then(() => setAddPage(false))
  }
  const pageEdit = (page) => {
    setEditPageData(page)
    setEditPage(true)
  }
  const updatePage = async (e) => {
    e.preventDefault()
    if (e.target.websitePageTitle.value === '' || e.target.websitePageTitle.value === null) {
      setErrors({ ...errors, websitePageTitle: { message: 'Page title is required!' } })
      return
    }
    if (
      errors.websitePageTitle &&
      (e.target.websitePageTitle.value !== '' || e.target.websitePageTitle.value !== null)
    ) {
      delete errors['websitePageTitle']
      setErrors(errors)
    }
    const payload = editPageData
    payload['websitePageTitle'] = e.target.websitePageTitle.value
    payload['defaultnav'] = e.target.defaultnav.checked ? 1 : 0
    await updateCallMutation.mutateAsync({
      url: isLocalEnvironment + '/updateData',
      apiEndpoint: 'websitePages',
      id: editPageData.websitePageId,
      data: payload,
      messageTitle: 'Website Pages',
      message: 'Page updated!',
      isDynamic: true,
      params: '&isDependency=true',
    })
    setEditPageData(null)
    setEditPage(false)
  }

  const openDelete = (data) => {
    setDeleteConfirm(true)
    setDeleteData(data)
  }

  const closeDelete = () => {
    setDeleteConfirm(false)
    setDeleteData(null)
  }

  const onDelete = async () => {
    await deleteCallMutation.mutateAsync({
      url: isLocalEnvironment + '/deleteData',
      apiEndpoint: 'websitePages',
      id: deleteData.websitePageId,
      messageTitle: 'Website Pages',
      message: 'Page deleted successfully!',
      isDynamic: true,
      params: '&isDependency=true',
    })
    setDeleteConfirm(false)
    setDeleteData(null)
  }

  return (
    <div
      className="trtui-modal trtui-modal-xxl trtui-fade trtui-show"
      aria-labelledby="exampleModalLabel"
      style={{
        display: 'block',
        backgroundColor: 'rgba(55,55,55,0.3)',
      }}
      aria-modal="true"
      role="dialog"
    >
      <div className="trtui-modal-dialog trtui-modal-dialog-scrollable trtui-modal-xl">
        <div className="trtui-modal-content">
          <div className="trtui-modal-header trtui-bg-light trtui-p-3">
            <div className="trtui-row trtui-w-100">
              <div className="trtui-col-6">
                <h5 className="trtui-modal-title" id="exampleModalLabel">
                  Manage Pages
                </h5>
              </div>
              <div className="trtui-col-6">
                <button
                  className="trtui-btn trtui-btn-primary truti-btn-sm"
                  onClick={() => setAddPage(true)}
                  style={{ float: 'inline-end', marginRight: '1rem' }}
                >
                  Add
                </button>
              </div>
            </div>
            <button
              type="button"
              className="trtui-btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closePages}
            >
              <i className="ri-close-line" />
            </button>
          </div>
          <div className="trtui-modal-body">
            <div className="trtui-row">
              {addPage ? (
                <>
                  <form className="trtui-row" onSubmit={createPage}>
                    <div className="trtui-col-6">
                      <input
                        type="text"
                        className={`trtui-form-control ${errorsAdd.websitePageName && 'trtui-is-invalid'}`}
                        placeholder="Page Name"
                        name="websitePageName"
                      />
                      {errorsAdd.websitePageName && (
                        <div className="trtui-invalid-feedback">
                          {errorsAdd.websitePageName.message}
                        </div>
                      )}
                    </div>
                    <div className="trtui-col-6">
                      <input
                        type="text"
                        className={`trtui-form-control ${errorsAdd.websitePageTitle && 'trtui-is-invalid'}`}
                        placeholder="Page Title"
                        name="websitePageTitle"
                      />
                      {errorsAdd.websitePageTitle && (
                        <div className="trtui-invalid-feedback">
                          {errorsAdd.websitePageTitle.message}
                        </div>
                      )}
                    </div>
                    <div className="trtui-col-12 trtui-mt-3">
                      <button
                        type="submit"
                        disabled={createCallMutation.isLoading}
                        className="trtui-btn trtui-btn-success"
                      >
                        {createCallMutation.isLoading ? (
                          <span className="trtui-d-flex trtui-align-items-center">
                            <span className="trtui-flex-grow-1 trtui-me-2">Adding...</span>
                            <span
                              className="trtui-spinner-border trtui-flex-shrink-0"
                              role="status"
                            >
                              <span className="trtui-visually-hidden">Adding...</span>
                            </span>
                          </span>
                        ) : (
                          'Add'
                        )}
                      </button>{' '}
                      <button
                        className="trtui-btn trtui-btn-secondary"
                        onClick={() => setAddPage(false)}
                        disabled={createCallMutation.isLoading}
                      >
                        Close
                      </button>
                    </div>
                  </form>
                </>
              ) : getProjectDetails.isLoading ? (
                <div>Loading...</div>
              ) : editPage ? (
                <form className="trtui-row" onSubmit={updatePage}>
                  <div className="trtui-col-6">
                    <label className="trtui-form-label">Page Title</label>
                    <input
                      type="text"
                      className={`trtui-form-control ${errors.websitePageTitle && 'trtui-is-invalid'}`}
                      placeholder="Page Title"
                      name="websitePageTitle"
                      defaultValue={editPageData.websitePageTitle}
                    />
                    {errors.websitePageTitle && (
                      <div className="trtui-invalid-feedback">
                        {errors.websitePageTitle.message}
                      </div>
                    )}
                  </div>
                  <div className="trtui-col-6">
                    <label className="trtui-form-label">SPA</label>
                    <div className="trtui-form-check">
                      <input
                        className="trtui-form-check-input"
                        type="checkbox"
                        name="defaultnav"
                        defaultChecked={editPageData.defaultnav}
                      />
                    </div>
                  </div>
                  <div className="trtui-col-12 trtui-mt-3">
                    <button
                      type="submit"
                      className="trtui-btn trtui-btn-success"
                      disabled={updateCallMutation.isLoading ? true : false}
                    >
                      {updateCallMutation.isLoading ? 'Updating...' : 'Update'}
                    </button>{' '}
                    <button
                      className="trtui-btn trtui-btn-secondary"
                      onClick={() => setAddPage(false)}
                      disabled={updateCallMutation.isLoading ? true : false}
                    >
                      Close
                    </button>
                  </div>
                </form>
              ) : deleteConfirm ? (
                <div>
                  <div className="trtui-mt-2 trtui-text-center">
                    <lord-icon
                      src="https://cdn.lordicon.com/gsqxdxog.json"
                      trigger="loop"
                      colors="primary:#f7b84b,secondary:#f06548"
                      style={{ width: '100px', height: '100px' }}
                    />
                    <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                      <h4>Are you Sure ?</h4>
                      <p className="trtui-text-muted trtui-mx-4 trtui-mb-0">
                        You want to delete this page ?
                      </p>
                    </div>
                  </div>
                  <div className="trtui-d-flex trtui-gap-2 trtui-justify-content-center trtui-mt-4 trtui-mb-2">
                    <button
                      type="button"
                      className="trtui-btn trtui-w-sm trtui-btn-light"
                      data-bs-dismiss="modal"
                      onClick={() => {
                        closeDelete()
                      }}
                      disabled={deleteCallMutation.isLoading}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="trtui-btn trtui-w-sm trtui-btn-danger"
                      onClick={() => onDelete()}
                      disabled={deleteCallMutation.isLoading}
                    >
                      {deleteCallMutation.isLoading ? 'Deleting...' : 'Yes, Delete It!'}
                    </button>
                  </div>
                </div>
              ) : (
                <div className="trtui-table-responsive">
                  <table className="trtui-table trtui-table-nowrap trtui-mb-0">
                    <thead>
                      <tr>
                        <th scope="col">Name</th>
                        <th scope="col">Path</th>
                        <th scope="col">Title</th>
                        <th scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {getProjectDetails.data.formData.length > 0 &&
                        getProjectDetails.data.formData.map((page, pageInd) => (
                          <tr key={pageInd}>
                            <th scope="row">{page.websitePageName}</th>
                            <th scope="row">{page.websitePageSlug}</th>
                            <th scope="row">{page.websitePageTitle}</th>
                            <th scope="row">
                              <span
                                className="trtui-link-info trtui-fs-15"
                                style={{ cursor: 'pointer' }}
                                onClick={() => pageEdit(page)}
                              >
                                <i className="ri-edit-2-line"></i>
                              </span>{' '}
                              <span
                                className="trtui-link-danger trtui-fs-15"
                                style={{ cursor: 'pointer' }}
                                onClick={() => openDelete(page)}
                              >
                                <i className="ri-delete-bin-line"></i>
                              </span>{' '}
                              <a
                                className="trtui-link-secondary trtui-fs-15"
                                title="Page Builder"
                                href={`page-editor?pageId=${page.websitePageId}&projectId=${page.websiteProjectId}&targetTenantId=${authDetails.session.user.appAdmin.tenantId}&targetAppId=${authDetails.session.user.appAdmin.appId}&targetOrgId=${authDetails.session.user.appAdmin.orgId}`}
                                onClick={() => {
                                  const storage = sessionStorage.getItem('auth')
                                  localStorage.setItem('sessionStorage', storage)
                                }}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <i className="ri-pages-line"></i>
                              </a>{' '}
                              <a
                                href={`/console/preview?project=${page.websiteProjectId}&theme=${pagesContent.themeId}&page=${page.websitePageId}`}
                                onClick={() => {
                                  const storage = sessionStorage.getItem('auth')
                                  localStorage.setItem('sessionStorage', storage)
                                }}
                                className="trtui-link-success trtui-fs-15"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <i className="ri ri-eye-line"></i>
                              </a>
                            </th>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

ProjectPages.propTypes = {
  closePages: PropTypes.func.isRequired,
  pagesContent: PropTypes.object.isRequired,
  isLocalEnvironment: PropTypes.string.isRequired,
  authDetails: PropTypes.object,
}
